import * as React from "react";
import { PillOption } from "./PillOption";
import { SelectOption } from "./types";

interface PillSelectProps {
  value: string[];
  onUpdate: (val: string[]) => void;
  options: SelectOption[];
  allowMultiple?: boolean;
  labeledBy?: string;
}

export const PillSelect = ({
  value,
  onUpdate,
  options,
  allowMultiple,
  labeledBy,
}: PillSelectProps) => {
  const toggleOption = (option: string) => {
    if (allowMultiple) {
      onUpdate(
        value.includes(option)
          ? value.filter((opt) => opt !== option)
          : [...value, option],
      );
    } else {
      onUpdate(value.includes(option) ? [] : [option]);
    }
  };

  return (
    <div
      role={allowMultiple ? "group" : "radiogroup"}
      aria-labelledby={labeledBy}
    >
      <ul className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isSelected = value.includes(option.value);
          return (
            <PillOption
              role={allowMultiple ? "checkbox" : "radio"}
              key={option.value}
              label={option.label}
              selected={isSelected}
              onToggle={() => toggleOption(option.value)}
            />
          );
        })}
      </ul>
    </div>
  );
};
